// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".doc-category .template-rule-name-select[data-v-52fe3afe] {\n  width: 110px !important;\n}\n.doc-category[data-v-52fe3afe] .el-radio__label {\n  font-size: 12px;\n  color: #000;\n}\n", ""]);
// Exports
module.exports = exports;
